export function productInstanceKey(fulfillmentMethod, productInstance) {
    const customParamsKey = customParameterInstancesKey(productInstance.customParameterInstances);
    const commonModifiersKey = modifierInstancesKey(productInstance.commonModifierInstances);
    const partsKey = productInstancePartsKey(fulfillmentMethod, productInstance.parts);
    const packagingFeeKey = productPackagingFeeIdKey(productInstance.productPackagingFeeId);
    return `ProductInstance[${customParamsKey},${commonModifiersKey},${packagingFeeKey}][${partsKey}]`;
}
export function productInstancePartsKey(fulfillmentMethod, parts) {
    let result = [];
    switch (parts.type) {
        case "SinglePart":
            result.push(fulfillmentMethodKey(fulfillmentMethod));
            result.push(isSplitKey(false));
            result.push(productTypeIdKey(parts.part.productTypeId));
            result.push(modifierInstancesKey(parts.part.modifierInstances));
            break;
        case "Halves":
            result.push(fulfillmentMethodKey(fulfillmentMethod));
            result.push(isSplitKey(true));
            result.push(productTypeIdKey(parts.first.productTypeId));
            result.push(modifierInstancesKey(parts.first.modifierInstances));
            result.push(productTypeIdKey(parts.second.productTypeId));
            result.push(modifierInstancesKey(parts.second.modifierInstances));
    }
    return result.join(",");
}
function fulfillmentMethodKey(fulfillmentMethod) {
    return `fulfillmentMethod=${fulfillmentMethod}`;
}
function isSplitKey(isSplit) {
    var _a;
    return `splitToHalves=${(_a = isSplit.toString()) !== null && _a !== void 0 ? _a : "null"}`;
}
function productPackagingFeeIdKey(productPackagingFeeId) {
    var _a;
    return `packagingFee=${(_a = productPackagingFeeId === null || productPackagingFeeId === void 0 ? void 0 : productPackagingFeeId.toString()) !== null && _a !== void 0 ? _a : "null"}`;
}
function productTypeIdKey(productTypeId) {
    return `productType_${productTypeId.toString()}`;
}
function customParameterInstancesKey(customParameterInstances) {
    return customParameterInstances.objects
        .map((instance) => { var _a, _b; return `parameter_${instance.typeId.toString()}=${(_b = (_a = instance.selectedChoice) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "null"}`; })
        .raw.join(":");
}
function modifierInstancesKey(modifierInstances) {
    return modifierInstances.objects
        .map((modifierInstance) => `modifier_${modifierInstance.typeId.toString()}->` +
        modifierInstance.selectedItems
            .map((modifierItemInstance) => { var _a, _b; return `${modifierItemInstance.typeId.toString()}:${(_b = (_a = modifierItemInstance.modifierItemPackagingFeeId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "null"}=${modifierItemInstance.quantity.toString()}`; })
            .raw.join("|"))
        .raw.join(":");
}
